import { z } from 'zod';
// eslint-disable-next-line unicorn/prevent-abbreviations
import type { ISharedRequestParams } from '../../models/request-parameters.models';

const SHARED_REQUEST_PARAMETERS_STORAGE_KEY = 'sharedParams';

const sharedRequestParametersSchema = z.object({
  accounts: z.array(z.number()).optional(),
  company_id: z.number().optional(),
  hasOnlyOneAccount: z.boolean().optional(),
});

/**
 * Reads the persisted account selection straight from `globalThis.localStorage`
 * rather than through `LocalStorageService`, because the store is created
 * before the injector has instantiated that service.
 *
 * Must be called every time the selection is needed. Reading it once at module
 * evaluation freezes the value chosen when the page was loaded, and every ngrx
 * state reset then resurrects it — including the reset that follows a logout,
 * which leaks the previous session's account selection into the next one.
 */
export const readSharedRequestParametersFromStorage = ():
  | ISharedRequestParams
  | undefined => {
  const storedValue = globalThis.localStorage.getItem(
    SHARED_REQUEST_PARAMETERS_STORAGE_KEY,
  );

  if (storedValue === null) {
    return undefined;
  }

  try {
    const result = sharedRequestParametersSchema.safeParse(
      JSON.parse(storedValue),
    );

    return result.success ? result.data : undefined;
  } catch {
    return undefined;
  }
};
